import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ArticleCards from './components/ArticleCards';
import SEOContent from './components/SEOContent';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://gtbuy.wtf';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'GTBuy Sheet',
  url: siteUrl,
  description: 'GTBuy Sheet is the ultimate product comparison system helping shoppers discover the best deals across Shoes, Hoodies, T-Shirts, Jackets, and more.',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://kaspreadsheet.com/search-{search_term}',
    'query-input': 'required name=search_term',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'GTBuy Sheet',
  url: siteUrl,
  description: 'Smart product comparison and discovery platform connecting shoppers to curated fashion and lifestyle products across 14 categories.',
  sameAs: ['https://kaspreadsheet.com'],
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <Navbar />
      <Hero />
      <CategorySection />
      <ArticleCards />
      <SEOContent />
      <CTASection />
      <Footer />
    </main>
  );
}